/** Static marketing preview of the live Overview UI. Does not load account data. */

const WEEK = [
  { label: "Mon", h: 42 },
  { label: "Tue", h: 58 },
  { label: "Wed", h: 36 },
  { label: "Thu", h: 74 },
  { label: "Fri", h: 61 },
  { label: "Sat", h: 28 },
  { label: "Sun", h: 18 },
];

const CALLS = [
  { name: "InterpreterCloud", meta: "Oct 6 · 2:14 PM", earnings: "$18.40", mins: "23 min" },
  { name: "LSA", meta: "Oct 6 · 11:02 AM", earnings: "$12.15", mins: "15 min" },
  { name: "InterpreterCloud", meta: "Oct 5 · 4:41 PM", earnings: "$24.80", mins: "31 min" },
];

export default function LandingProductPreview() {
  return (
    <div className="mpl-frame" aria-hidden="true">
      <div className="mpl-frame-bar">
        <span />
        <span />
        <span />
        <em>MinutePay · Overview</em>
      </div>
      <div className="mpl-frame-body mpd-page">
        <div className="mpd-page-head">
          <div>
            <h2>Overview</h2>
            <p className="mpd-sub">This week</p>
          </div>
          <span className="mpd-license is-on">
            <strong>Free Trial</strong>
            <em>6d left</em>
          </span>
        </div>

        <section className="mpd-kpis">
          <article className="mpd-kpi is-featured">
            <span>Earnings</span>
            <strong>$1,284.50</strong>
            <p>This week</p>
          </article>
          <article className="mpd-kpi">
            <span>Minutes</span>
            <strong>612</strong>
            <p>Worked time</p>
          </article>
          <article className="mpd-kpi">
            <span>Calls</span>
            <strong>47</strong>
            <p>Completed</p>
          </article>
          <article className="mpd-kpi">
            <span>Avg duration</span>
            <strong>13:01</strong>
            <p>Per call</p>
          </article>
        </section>

        <section className="mpd-card mpd-week-card">
          <div className="mpd-card-head">
            <div>
              <h2>Weekly income performance</h2>
              <p>Mon–Sun</p>
            </div>
            <span className="mpd-delta is-up">+12% vs last week</span>
          </div>
          <div className="mpl-bars">
            {WEEK.map((day) => (
              <div key={day.label} className="mpl-bar-col">
                <span style={{ height: `${day.h}%` }} />
                <em>{day.label}</em>
              </div>
            ))}
          </div>
        </section>

        <section className="mpd-grid-2 mpd-grid-side">
          <article className="mpd-card">
            <div className="mpd-card-head">
              <h2>Monthly goal</h2>
              <p>October</p>
            </div>
            <div className="mpd-goal-panel is-compact">
              <p className="mpd-goal-amt">
                $4,000.00
                <span>Monthly goal · October</span>
              </p>
              <div className="mpd-goal-progress">
                <div className="mpd-bar mpd-bar-lg">
                  <span style={{ width: "62%" }} />
                </div>
                <strong>62.0%</strong>
              </div>
              <div className="mpd-goal-grid">
                <div>
                  <span>Earned</span>
                  <strong>$2,480.00</strong>
                </div>
                <div>
                  <span>Remaining</span>
                  <strong>$1,520.00</strong>
                </div>
                <div>
                  <span>Daily pace</span>
                  <strong>$60.80/day</strong>
                </div>
              </div>
            </div>
          </article>
          <article className="mpd-card">
            <div className="mpd-card-head">
              <h2>Recent calls</h2>
              <p>Synced from the extension</p>
            </div>
            <ul className="mpd-recent">
              {CALLS.map((call) => (
                <li key={call.meta}>
                  <div>
                    <strong>{call.name}</strong>
                    <p>{call.meta}</p>
                  </div>
                  <div className="mpd-recent-right">
                    <strong>{call.earnings}</strong>
                    <p>{call.mins}</p>
                  </div>
                </li>
              ))}
            </ul>
          </article>
        </section>
      </div>
    </div>
  );
}
